import { Report1916 } from "../../../components/borrowSystem/Report/Report1916";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report1916Container() {
  const titleName =
    " แบบเก็บข้อมูลแบบติดตามประเมินผลการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน (แบบ กย.6)";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report1916 />
      <Footer />
    </div>
  );
}
